import React, { forwardRef } from "react";
import { Pressable, StyleSheet, Text, View, Image } from "react-native";
import disgoChipIcon from "../../../assets/disgo-chip-icon.png";

const HousePickOptionChip = forwardRef(function HousePickOptionChip(
  {
    label,
    isSelected,
    onPress,
    containerStyle,
    labelStyle,
    labelNumberOfLines = 2,
    compact = false,
  },
  ref
) {
  return (
    <View
      ref={ref}
      collapsable={false}
      style={[styles.optionItem, compact && styles.optionItemCompact, containerStyle]}
    >
      <Pressable onPress={onPress} style={styles.pressable}>
        <View
          style={[
            styles.optionCard,
            compact && styles.optionCardCompact,
            isSelected && styles.optionCardSelected,
          ]}
        >
          <Image
            source={disgoChipIcon}
            style={styles.chipIcon}
            resizeMode="contain"
          />
        </View>

        <Text
          numberOfLines={labelNumberOfLines}
          style={[
            styles.optionText,
            compact && styles.optionTextCompact,
            isSelected && styles.optionTextSelected,
            labelStyle,
          ]}
        >
          {label}
        </Text>
      </Pressable>
    </View>
  );
});

const styles = StyleSheet.create({
  optionItem: {
    width: "48.5%",
    marginBottom: 8,
    alignItems: "center",
  },
  optionItemCompact: {
    marginBottom: 0,
  },
  pressable: {
    width: "100%",
    alignItems: "center",
  },
  optionCardCompact: {
    width: "48%",
  },
  optionCard: {
    width: "55%",
    alignSelf: "center",
    aspectRatio: 1,
    borderWidth: 0,
    borderRadius: 999,
    backgroundColor: "transparent",
    boxShadow: "0px 2px 6px rgba(0,0,0,0.08)",
    padding: 0,
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  optionCardSelected: {
    backgroundColor: "transparent",
  },
  chipIcon: {
    width: "100%",
    height: "100%",
  },
  optionTextCompact: {
    marginTop: 2,
    minHeight: 24,
    fontSize: 13,
    lineHeight: 15,
  },
  optionText: {
    marginTop: 3,
    width: "80%",
    minHeight: 28,
    alignSelf: "center",
    fontSize: 14,
    color: "#6B4C3B",
    fontFamily: "AbhayaLibre_700Bold",
    textAlign: "center",
    lineHeight: 16,
    maxWidth: "80%",
  },
  optionTextSelected: {
    color: "#4e2916",
  },
});

export default HousePickOptionChip;
